const extractLinkData = require("./extractLinkData");
const extractButtonData = require("./extractButtonData");

module.exports = function transformButtonsData(entity, sitemap, singleRelationships) {
	const { attributes, relationships } = entity;

	let links = [];

	const primary =
		attributes && attributes.field_primary_button
			? extractLinkData(attributes.field_primary_button, sitemap, singleRelationships)
			: null;
	const secondary =
		attributes && attributes.field_secondary_button
			? extractLinkData(attributes.field_secondary_button, sitemap, singleRelationships)
			: null;

	if (primary) {
		links.push({ ...primary, color: "primary", type: "default" });
	}
	if (secondary) {
		links.push({ ...secondary, color: "secondary", type: "default" });
	}

	let more_links =
		attributes.field_buttons &&
		Array.isArray(attributes.field_buttons) &&
		attributes.field_buttons.length > 0
			? attributes.field_buttons
			: null;

	const buttonColor = attributes.field_color ? attributes.field_color : "secondary";
	const buttonStyle = attributes.field_button_style
		? attributes.field_button_style
		: "default";

	const centered = attributes.field_centered ? attributes.field_centered : false;

	const button_entities =
		relationships && relationships.field_buttons_entities
			? relationships.field_buttons_entities
			: null;

	if (button_entities && button_entities.data) {
		button_entities.data.forEach((btn) => {
			const btn_data = extractButtonData(btn, sitemap, singleRelationships);
			if (btn_data) {
				links.push(btn_data);
			}
		});
	}

	if (more_links) {
		more_links = more_links.map((l) => ({
			...extractLinkData(l, sitemap, singleRelationships),
			color: buttonColor,
			type: buttonStyle,
		}));
		links = [...links, ...more_links];
	}

	links = links.map((link) => ({
		type: buttonStyle,
		color: buttonColor,
		...link,
	}));

	return { id: entity.id, type: entity.type, singleColumn: false, links, centered };
};
